import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WsToggleButton, WsAutocompleteInput } from 'wisestep-base';

import WsAccordion from './WsAccordion';

interface MultiMatchFilterProps {
  name: string;
  title: string;
  placeholder: string;
  multiple?: boolean;
  options?: string[];
  matchTypeFieldName?: string;
  startIcon?: React.ReactElement;
}

const MultiMatchFilter = ({
  name,
  title,
  placeholder,
  multiple = true,
  options = [],
  matchTypeFieldName = '',
  startIcon,
}: MultiMatchFilterProps) => {
  const { setValue, getValues } = useFormContext();

  return (
    <WsAccordion title={title} {...(startIcon && { startIcon: startIcon })}>
      <Grid container spacing={2}>
        <Grid item xs={matchTypeFieldName ? 8 : 12}>
          <WsAutocompleteInput
            name={name}
            options={options}
            multiple={multiple}
            freeSolo
            placeholder={placeholder}
          />
        </Grid>
        {matchTypeFieldName && (
          <Grid item xs={2}>
            <WsToggleButton
              buttonsList={[
                { label: 'AND', value: 'AND' },
                { label: 'OR', value: 'OR' },
              ]}
              selectedIndexValue={(value) => setValue(matchTypeFieldName, value)}
              defaultValue={getValues(matchTypeFieldName)}
            />
          </Grid>
        )}
      </Grid>
    </WsAccordion>
  );
};
export default MultiMatchFilter;
